module.exports = __webpack_public_path__ + "static/media/Banner_home_celular.edccc580.png";